/* eslint-disable @typescript-eslint/no-explicit-any */
import { StorageService } from './storage.service';

export function withInMemoryCache<T extends StorageService>(target: T) {
  const InMemoryStore = new Map<string, unknown>();

  const originalGetItem = target.getItem.bind(target);
  const originalRetrieve = target.retrieve.bind(target);
  const originalSetItem = target.setItem.bind(target);
  const originalStore = target.store.bind(target);
  const originalRemoveItem = target.removeItem.bind(target);
  const originalClear = target.clear.bind(target);

  target.getItem = <T = any>(key: string): T | null => {
    if (InMemoryStore.has(key)) {
      return (InMemoryStore.get(key) as T) ?? null;
    }
    const value = originalGetItem(key);
    if (value !== null) {
      InMemoryStore.set(key, value);
    }
    return value;
  };
  target.retrieve = <T = any>(key: string): T | null => {
    if (InMemoryStore.has(key)) {
      return (InMemoryStore.get(key) as T) ?? null;
    }
    const value = originalRetrieve(key);
    if (value !== null) {
      InMemoryStore.set(key, value);
    }
    return value;
  };
  target.setItem = <T = any>(key: string, value: T): void => {
    InMemoryStore.set(key, value);
    originalSetItem(key, value);
  };
  target.store = <T = any>(key: string, value: T): void => {
    InMemoryStore.set(key, value);
    originalStore(key, value);
  };
  target.removeItem = (key: string): void => {
    InMemoryStore.delete(key);
    originalRemoveItem(key);
  };
  target.clear = (key?: string): void => {
    if (key) {
      InMemoryStore.delete(key);
      originalClear(key);
    } else {
      InMemoryStore.clear();
      originalClear(key);
    }
  };
  return target;
}
